import { Component, OnInit } from '@angular/core';
import { FormApiService } from '@app/core/services/form-api.service';
import { ChargeInformationDto, ChargeInformationService } from '@app/api/dmc';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputDirective } from '@shared/components/input/input/input.directive';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-chargeinformation-close',
  imports: [
    InputDirective,
    InputGroupComponent,
    LabelDirective,
    ReactiveFormsModule,
    TranslatePipe
  ],
  templateUrl: './chargeinformation-close.component.html',
  styleUrl: './chargeinformation-close.component.css'
})
export class ChargeinformationCloseComponent implements OnInit {
  public chargeInformationDto?: ChargeInformationDto;
  public form: FormGroup = new FormGroup({
    chargeType: new FormControl(null),
    chargeTypeId: new FormControl(''),
    description: new FormControl(''),
    validTo: new FormControl('', Validators.required),
  });

  constructor(
    private readonly formApiService: FormApiService,
    private readonly chargeInformationService: ChargeInformationService,
  ) {
  }

  public ngOnInit(): void {
    if (this.chargeInformationDto) {
      this.form.patchValue({
        chargeType: this.chargeInformationDto.chargeType,
        chargeTypeId: this.chargeInformationDto.chargeTypeId,
        description: this.chargeInformationDto.description,
        validTo: this.chargeInformationDto.validTo,
      });
    }
  }

  public close(): void {
    const updatedChargeInfo: ChargeInformationDto = {
      ...this.chargeInformationDto,
      validTo: this.form.get('validTo')?.value
    };
    this.formApiService.submit(
      this.form,
      () => this.chargeInformationService.chargeInformationStopChargeInformationPut(updatedChargeInfo),
      {
        successMessage: 'chargeInformation.chargeInformationClosed',
        closeModal: true,
      }
    );
  }
}
